import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  AppstoreOutlined,
  BarcodeOutlined,
  GroupOutlined,
  MailOutlined,
  OrderedListOutlined,
  SettingOutlined,
  SolutionOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import type { MenuProps } from "antd";
import { useCurrentUser } from "../hooks/useCurrentUser";

type MenuItem = Required<MenuProps>["items"][number];

function getItem(
  label: React.ReactNode,
  key: string,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: "group"
): MenuItem {
  return { key, icon, children, label, type } as MenuItem;
}

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: currentUser } = useCurrentUser();
  const isAdmin = currentUser?.roleName === "Admin";

  const items: MenuItem[] = [
    getItem("Vehicle Config", "/vehicle_config", <AppstoreOutlined />),
    getItem("Canny Manager", "/canny", <BarcodeOutlined />),
    getItem("Firmware Manager", "/firmware_manager", <SettingOutlined />),
    getItem("Record Data", "/record_data", <OrderedListOutlined />),
    getItem("Smart Buttons", "/smart_buttons", <GroupOutlined />),
    getItem("Mobile Notification", "/mobile_notification", <MailOutlined />),
    ...(isAdmin ? [getItem("IAM Manager", "/user", <SolutionOutlined />)] : []),
  ];

  const onClick: MenuProps["onClick"] = (e) => {
    navigate(e.key);
  };

  return (
    <Menu
      onClick={onClick}
      selectedKeys={[location.pathname]}
      mode="inline"
      theme="dark"
      items={items}
    />
  );
};

export default Sidebar;
